import { httpRequest } from "@/lib";
import { FrequencyResponse } from "@/types";
import { useQuery } from "@tanstack/react-query";

type Props = {
  page?: string;
  search?: string;
};

async function fetchFrequencies({
  search = "",
  page = "1",
}: Props): Promise<FrequencyResponse> {
  const response = await httpRequest.get<FrequencyResponse>(
    `/frequencies?page=${page}&search=${search}`
  );
  return response.data;
}

export function useFetchFrequenciesQuery(props: Props) {
  const frequenciesQuery = useQuery({
    queryKey: ["frequencies", props.page || "1", props.search],
    queryFn: () => fetchFrequencies(props),
    keepPreviousData: true,
  });

  return {
    ...frequenciesQuery,
    data: frequenciesQuery?.data,
  };
}
